import { Injectable } from '@angular/core';
import { RewardEntity } from '@features/menu/models/menu.models';

import { ParentRecipeEntity } from '@core/redux/stores';

@Injectable()
export class RewardItemService {

  public rewards: Array<RewardEntity>;
  public currentRewardItem: RewardEntity;
  public rewardItemParentRecipe: ParentRecipeEntity;

  constructor() { }

  updateRewardItems(rewardItems) {
    this.rewards = rewardItems;
  }

  updateCurrentRewardItem(rewardItem) {
    this.currentRewardItem = rewardItem;
  }

  updateRewardItemParentRecipe(parentRecipe) {
    this.rewardItemParentRecipe = parentRecipe;
  }

}
